import { Leg } from '@api/Trinium/Endpoints/Leg';
import { ContainerFormik } from '@forms/Container/types';
import { Field, Form, useFormikContext } from 'formik';
import { ContainerSubform } from '@forms/Container/Form';

import styles from './MakeContainerAvailable.module.css';

interface FormikFormProps {
	id: string;
	leg?: Leg;
	bulk?: boolean;
	/** Bulk mode only - disable a date field when even one selected order's leg can't have that field set */
	bulkFullAvailableDisabled?: boolean;
	bulkEmptyAvailableDisabled?: boolean;
	bulkChassisAvailableDisabled?: boolean;
}

export default function FormikForm({ id, bulk, bulkFullAvailableDisabled, bulkEmptyAvailableDisabled, bulkChassisAvailableDisabled }: FormikFormProps) {
	const formik = useFormikContext<ContainerFormik>();

	return (
		<Form
			className={styles.form}
			id={id}
		>
			<Field
				name='containerForm'
				component={ContainerSubform}
				value={formik.values}
				availabilityDatesOnly={bulk}
				bulkFullAvailableDisabled={bulkFullAvailableDisabled}
				bulkEmptyAvailableDisabled={bulkEmptyAvailableDisabled}
				bulkChassisAvailableDisabled={bulkChassisAvailableDisabled}
			/>
		</Form>
	);
}
